import styled from 'styled-components';
import { Modal } from 'react-inv-forms';

export const CustomModal = styled(Modal)`
  max-width: 90%;
  min-width: 60%;
  @media (max-width: 768px) {
    max-width: unset;
    min-width: 90%;
  }
  @media (max-width: 667px) {
    width: 90vw;
  }
  .ant-select {
    width: 100%;
  }
`;